export const convertBase64ToFile = async (base64: string, filename: string): Promise<File> => {
	const res = await fetch(base64);
	const blob = await res.blob();
	return new File([blob], filename, { type: "image/jpeg" });
};
